export default __webpack_public_path__ + "static/media/building.png?.b80b8611";